'use client';
import React, { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { categoriesData, dataCountry, years } from '@/data/constants';

function DrawerHeader() {
  const [isVisible, setIsVisible] = useState(false);
  const [focus, setFocus] = useState<string>('');

  const toggleList = (value: string) => {
    if (focus) {
      setIsVisible(true);
    } else {
      setIsVisible(!isVisible);
    }
    setFocus(value);
  };
  return (
    <div className="h-full bg-colorMain w-[270px] px-3 py-4">
      {/* <div className="w-full p-7 bg-colorMainOver">
        <div className="bg-redMain w-full py-3 text-[13px] text-white font-medium rounded text-center cursor-pointer">
          Đăng nhập
        </div>
      </div> */}
      <div className="text-white text-[12px] font-medium mt-6">
        <a href={`/`} className="uppercase flex justify-between items-center text-white">
          <div>Trang chủ</div>
        </a>
        <a
          href={`/danh-sach/tv-shows`}
          className="uppercase flex justify-between items-center text-white mt-3"
        >
          <div>TV Show</div>
        </a>
        <a
          href={`/danh-sach/phim-le`}
          className="uppercase flex justify-between items-center text-white mt-3"
        >
          <div>Phim Lẻ</div>
        </a>
        <a
          href={`/danh-sach/phim-bo`}
          className="uppercase flex justify-between items-center text-white mt-3"
        >
          <div>Phim Bộ</div>
        </a>
        <a
          href={`/danh-sach/phim-dang-chieu`}
          className="uppercase flex justify-between items-center text-white mt-3"
        >
          <div>Phim Đang Chiếu</div>
        </a>
        <div
          className="uppercase flex justify-between items-center text-white mt-3"
          onClick={() => {
            toggleList('categories');
          }}
        >
          <div>Thể loại phim</div>
          <IoIosArrowDown size={16} className="text-yellowMain" />
        </div>
        <div
          className={`transition-[max-height] duration-500 ease-in-out overflow-hidden bg-colorMainOver ${
            isVisible && focus === 'categories' ? 'max-h-96' : 'max-h-0'
          }`}
        >
          <div className="px-3 py-2 text-white text-[10px] grid grid-cols-2 gap-2">
            {categoriesData.map((val) => {
              return (
                <a href={`/the-loai/${val.slug}`} key={val.slug}>
                  {val.title}
                </a>
              );
            })}
          </div>
        </div>
        <div
          className="uppercase flex justify-between items-center text-white mt-3"
          onClick={() => {
            toggleList('nation');
          }}
        >
          <div>Quốc gia</div>
          <IoIosArrowDown size={16} className="text-yellowMain" />
        </div>
        <div
          className={`transition-[max-height] duration-500 ease-in-out overflow-hidden bg-colorMainOver ${
            isVisible && focus === 'nation' ? 'max-h-96' : 'max-h-0'
          }`}
        >
          <div className="px-3 py-2 text-white text-[10px] grid grid-cols-2 gap-2">
            {dataCountry.map((val) => {
              return (
                <a href={`/quoc-gia/${val.slug}`} key={val.slug}>
                  {val.title}
                </a>
              );
            })}
          </div>
        </div>
        <div
          className="uppercase flex justify-between items-center text-white mt-3"
          onClick={() => {
            toggleList('year');
          }}
        >
          <div>Năm sản xuất</div>
          <IoIosArrowDown size={16} className="text-yellowMain" />
        </div>
        <div
          className={`transition-[max-height] duration-500 ease-in-out overflow-hidden bg-colorMainOver ${
            isVisible && focus === 'year' ? 'max-h-96' : 'max-h-0'
          }`}
        >
          <div className="px-3 py-2 text-white text-[10px] grid grid-cols-2 gap-2">
            {years.map((val) => {
              return (
                <a href={`/nam/${val}`} key={val}>
                  {val}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DrawerHeader;
